import { ResponsiveContainer, ComposedChart, XAxis, YAxis, Bar, Line, Tooltip, LabelList } from "recharts";
import { numberFormatter } from "../../utils";

interface Props {
    chartData: Array<T>
}

interface T {
    quarter: string,
    actualRebate: number,
    projectedRebate: number,
    targetRebate: number,
    cumulativeCurrent: number,
    cumulativeTarget: number
}

const RebateChart = (props: Props) => {
    const data = props.chartData;

    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="custom-tooltip">
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Quarter : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.quarter}</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Current Rebate Cumulative($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.cumulativeCurrent)}</label></p>
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Target Rebate Cumulative($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.cumulativeTarget)}</label></p>
                    {data.actualRebate > 0 && <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Actual Rebate($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.actualRebate)}</label></p>}
                    {(data.projectedRebate > 0 || data.targetRebate > 0) && <><p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Projected Rebate($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.projectedRebate)}</label></p>

                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Target Rebate($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.targetRebate)}</label></p>
                    </>
                    }
                </div>
            )
        }
    }


    return (
        <ResponsiveContainer width="100%" height="100%" maxHeight={300}>
            <ComposedChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}

            >
                <XAxis
                    dataKey="quarter"
                    stroke="white"
                />
                <YAxis stroke="white" tickFormatter={(value: number) => numberFormatter(value, 0, '$')} />
                <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3" }} content={customTooltip} />
                {/* <Legend /> */}
                <Bar dataKey="actualRebate" fill="#98F5F9" barSize={30}>
                    <LabelList dataKey='actualRebate' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                <Bar dataKey="projectedRebate" fill="#EAB308" barSize={30}>
                    <LabelList dataKey='projectedRebate' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                <Bar dataKey="targetRebate" fill="#9ACD32" barSize={30}>
                    <LabelList dataKey='targetRebate' fill="white" fontSize="12px" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="top"></LabelList>
                </Bar>
                {data[3].cumulativeCurrent > 0 && < Line type="linear" dataKey="cumulativeCurrent" stroke="#EAB308" connectNulls={true} strokeWidth={2} strokeDasharray="5 5" />}
                {data[3].cumulativeTarget > 0 && <Line type="linear" dataKey="cumulativeTarget" stroke="#9ACD32" connectNulls={true} strokeWidth={2} strokeDasharray="5 5" />}
            </ComposedChart>
        </ResponsiveContainer>
    )
}

export default RebateChart;